module.exports = __webpack_public_path__ + "static/media/koby-1.578ffc85.jpeg";